import prod from "./configureStore.prod";
import dev from "./configureStore.dev";

export default import.meta.env.MODE === "production" ? prod : dev;
